export default __webpack_public_path__ + "static/vue-2ab193337e3ce9be9155b6431396d3bb.png";